import React, {useState} from "react";
import './wizard.css';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { ImArrowLeft } from 'react-icons/im';

// * Helpers
import { useTranslation } from 'react-i18next';
import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';

// * Axios
import API from "../../services/api";

const Step10 = (props) => {

    // * we call the hook to make translations
    const { t } = useTranslation('common');

    const [showAlert, setShowAlert] = useState(false);

    // * This function is called when the PREVIOUS arrow is clicked.
    // * It is passed as parameter to each step 
    const onPreviousClick = () => {
        props.changeStep(9);
    }

    // Calculate Model click action
    const onCompleteClick = async () => {
        try {
            const response = await API.get(`Model/updateIsModelCompleted`, {
                params: {
                    modelId:props.modelData.modelid,
                    isModelCompleted: true
                }
            });
            if (response.data.code === 100) {
                Notifications.notify(t('model.step10_complete_success'), SUCCESS_NOTIFICATION);
                toggleAlert();
                props.setFlags();
                onPreviousClick();
            }else{
                Notifications.notify('model.step10_complete_error', ERROR_NOTIFICATION);
                toggleAlert();
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            toggleAlert();
            console.log(e);
        }
        
    }

    const toggleAlert = () => {
        setShowAlert(!showAlert);
    }

    const validateIsReadyForAssessment = async () => {
        try {
            const response = await API.get(`Model/getModelFlags?modelId=${props.modelData.modelid}`);
            
            if (response.data.code === 100) {
                const isReadyForAssessment = response.data.data.isReadyForAssessment
                if (isReadyForAssessment){
                    toggleAlert();
                }else{
                    Notifications.notify(t('model.step10_model_no_calculated'), ERROR_NOTIFICATION);        
                }
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    return (
        <div className="col-md-12">
            {/* alert window */}
            {showAlert &&
                <Dialog
                    className="ilo-wizard-complete"
                    title={t('model.step10_dialog_title')}
                    onClose={() => toggleAlert()}
                >
                    <h5 style={{ textAlign: "center", width: '60%', margin: 'auto'}}>{t('model.step10_dialog_content')}</h5>
                    <DialogActionsBar layout="end">
                        <button className="k-button" onClick={onCompleteClick}>{t('model.step10_dialog_confirm')}</button>
                        <button className="k-button" onClick={toggleAlert}>{t('model.step10_dialog_cancel')}</button>
                    </DialogActionsBar>
                </Dialog>
            }
            <div className="row">
                <h6>{t('model.step10_desc')}</h6>
            </div>
            <div className="row row_attrs container_steps align-items-center" style={{ textAlign: "center" }}>
                <div className="col-sm-12">
                    <button
                        className="btn_complete_model_def"
                        type="button"
                        onClick={() => { validateIsReadyForAssessment(); }}
                    >
                        {t('model.step10_complete_btn')}
                    </button>
                </div>
            </div>
            <div className="row arrows_position">
                <div className="col-sm-12">
                    <button className="btn_style" type="button" onClick={() => { onPreviousClick(); }} ><ImArrowLeft /></button>
                </div>
            </div>
        </div>
    );
}

export default Step10